import { render } from "./tarifs.vue?vue&type=template&id=8702ef80&scoped=true"
import script from "./tarifs.vue?vue&type=script&lang=js"
export * from "./tarifs.vue?vue&type=script&lang=js"

import "./tarifs.vue?vue&type=style&index=0&id=8702ef80&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8702ef80"]])

export default __exports__